import { render, staticRenderFns } from "./ApiExternal.vue?vue&type=template&id=5fca938c"
import script from "./ApiExternal.vue?vue&type=script&lang=js"
export * from "./ApiExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports